export default __webpack_public_path__ + "static/media/logo_pln.7561135b.png";